import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        // Detect environment to set URL (localhost vs production)
        const URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

        // Fix malformed URL: Remove /api, trailing slashes, AND ensure no double protocol
        const socketUrl = URL.replace(/\/api\/?$/, '').replace(/\/$/, '');

        console.log('Initializing Agent Socket.io connection to:', socketUrl);

        const newSocket = io(socketUrl, {
            path: '/socket.io',
            transports: ['polling', 'websocket'],
            withCredentials: true,
            auth: {
                token: localStorage.getItem('agentToken')
            },
            autoConnect: true,
            reconnection: true,
        });

        setSocket(newSocket);

        newSocket.on('connect', () => {
            console.log('Agent/Admin Socket connected:', newSocket.id);

            // Join admin room if authenticated
            const userStr = localStorage.getItem('agent');
            if (userStr) {
                try {
                    const user = JSON.parse(userStr);
                    // Join if admin/agent
                    if (user.role) {
                        newSocket.emit('join_check_admin', user.role);
                    }
                } catch (e) {
                    console.error('Error parsing agent from local storage', e);
                }
            }
        });

        newSocket.on('connect_error', (err) => {
            console.error('Agent Socket connection error:', err);
        });

        return () => newSocket.close();
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
